import { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  adminListUsers,
  adminResetPassword,
  isUnauthorized,
} from '../lib/api';
import AdminNav from './AdminNav';

type Row = {
  id: string;
  login_key: string;
  login_type: string;
  display_name: string | null;
  status: string;
  created_at: string;
};

export default function AdminUsers() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [users, setUsers] = useState<Row[]>([]);
  const [error, setError] = useState('');
  const [resetId, setResetId] = useState<string | null>(null);
  const [newPass, setNewPass] = useState('');
  const [shownOnce, setShownOnce] = useState('');

  async function load(query?: string) {
    try {
      const { users: list } = await adminListUsers(query);
      setUsers(list);
    } catch (err) {
      if (isUnauthorized(err)) {
        navigate('/admin/login', { replace: true });
        return;
      }
      setError('用户列表加载失败');
    }
  }

  useEffect(() => {
    load();
  }, [navigate]);

  async function onSearch(e: FormEvent) {
    e.preventDefault();
    await load(q.trim() || undefined);
  }

  async function onReset(e: FormEvent) {
    e.preventDefault();
    if (!resetId || newPass.length < 8) {
      setError('新密码至少 8 位');
      return;
    }
    try {
      await adminResetPassword(resetId, newPass);
      setShownOnce(newPass);
      setNewPass('');
      setResetId(null);
      setError('');
    } catch {
      setError('重置失败');
    }
  }

  return (
    <section className="stack">
      <AdminNav />
      <div className="card stack">
        <h2>用户</h2>
        <p className="muted">验证期无自助找回；在此按登录标识搜索并重置密码。</p>
        <form className="row" onSubmit={onSearch}>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="login_key" />
          <button className="btn" type="submit">搜索</button>
        </form>
        {error ? <div className="error">{error}</div> : null}
        {shownOnce ? (
          <p className="legal-draft">已重置。请立即把新密码告知用户（仅此一次展示）：<code>{shownOnce}</code></p>
        ) : null}
        <table className="admin-table">
          <thead>
            <tr>
              <th>标识</th>
              <th>类型</th>
              <th>显示名</th>
              <th>状态</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td className="mono">{u.login_key}</td>
                <td>{u.login_type}</td>
                <td>{u.display_name || '—'}</td>
                <td>{u.status}</td>
                <td>
                  <button type="button" className="btn btn-ghost" onClick={() => setResetId(u.id)}>
                    重置密码
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {resetId ? (
          <form className="stack" onSubmit={onReset}>
            <label>
              新密码（≥8）
              <input type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} minLength={8} required />
            </label>
            <button className="btn" type="submit">确认重置</button>
          </form>
        ) : null}
      </div>
    </section>
  );
}
